/* /ess/profile — own profile, salary, EOSB accrual (prototype pgEssProfile). */
import { useNavigate } from "react-router-dom";
import { useSession } from "../../app/session";
import { useEmployee, useToday } from "../../data/hooks";
import { eosb } from "../../domain/payroll";
import { useI18n } from "../../i18n";
import { Avatar, Button, Card, DualDate, Kv, Loaded, Money, errMsg, useToast } from "../../ui";
import ChangePasswordCard from "../account/ChangePasswordCard";
import { NoLink } from "./EssHome";
import { useEmployeeId } from "./essLib";
import { activeCode } from "../../lib/country";

function Body({ empId }: { empId: number }) {
  const { t, L, name, title, dept, nat, branch } = useI18n();
  const { logout } = useSession();
  const nav = useNavigate();
  const toast = useToast();
  const today = useToday();
  const q = useEmployee(empId);
  const signOut = async () => { try { await logout(); } catch (e) { toast(errMsg(e), "bad"); } nav("/login"); };
  return (
    <Loaded q={q}>{(e) => {
      const eo = eosb(e, today, "termination", undefined, activeCode());
      return (
        <div className="ess stack lg" data-testid="ess-profile">
          <section className="card prof">
            <Avatar name={e.nameEn} size="lg" />
            <div className="grow"><h1>{name(e)}</h1><div className="sm muted">{title(e.title)} · {dept(e.dept)} · <span className="num">{e.code}</span></div></div>
          </section>
          <Card title={t("Personal")}>
            <Kv items={[[t("Mobile"), <span key="m" className="num" dir="ltr">{e.mobile}</span>], [t("Email"), e.email], [e.nationality === "SA" ? L("National ID", "الهوية الوطنية") : t("Iqama"), <span key="i" className="num">{e.idNumber}</span>], [t("Nationality"), nat(e.nationality)], [L("Branch", "الفرع"), branch(e.branch)], [t("Joined"), <DualDate key="j" date={e.joined} />]]} />
          </Card>
          <Card title={t("Salary & allowances")}>
            <Kv items={[[t("Basic salary"), <Money key="b" value={e.basic} />], [t("Housing"), <Money key="h" value={e.housing} />], [t("Transport"), <Money key="t" value={e.transport} />], ...(e.other ? [[L("Other", "أخرى"), <Money key="o" value={e.other} />] as [string, JSX.Element]] : []), [t("Bank"), e.bank], [t("IBAN"), <span key="ib" className="num" dir="ltr">{e.iban}</span>]]} />
          </Card>
          <Card title={t("EOSB accrual")} testId="eosb-card">
            <div className="kpi-v" data-testid="eosb-award"><Money value={eo.award} /></div>
            <p className="sm muted" style={{ margin: "4px 0 0" }}>{L(`Estimated after ${eo.years.toFixed(1)} years of service (Labor Law Arts. 84–85)`, `تقديري بعد ${eo.years.toFixed(1)} سنوات خدمة (نظام العمل المادتان 84–85)`)}</p>
          </Card>
          <ChangePasswordCard />
          <p className="xs muted" style={{ margin: 0 }}>{L("Something wrong? Ask HR to correct your details — every change is recorded in the audit log.", "هل هناك خطأ؟ اطلب من الموارد البشرية تصحيح بياناتك — كل تغيير يُسجل في سجل التدقيق.")}</p>
          <div className="row"><Button variant="ghost" icon="log-out" onClick={signOut} data-testid="ess-signout">{t("Sign out")}</Button></div>
        </div>
      );
    }}</Loaded>
  );
}

export default function EssProfile() {
  const id = useEmployeeId();
  return id == null ? <NoLink /> : <Body empId={id} />;
}
